export enum ServerType {
	CCure = 1234
}
